module.exports = __webpack_public_path__ + "static/media/pelvis_obl.73d97bce.png";